// removed by extract-text-webpack-plugin
module.exports = {"footer":"fq_t","container":"fq_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/DiscoverFooter/styles.module.css
// module id = 1230
// module chunks = 27